import { render, staticRenderFns } from "./description-setting.vue?vue&type=template&id=b8ed0b50"
import script from "./description-setting.vue?vue&type=script&lang=js"
export * from "./description-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports